exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav .type a{display:block;width:100%;height:100%;color:#000;padding-bottom:.05rem}.nav .type a:hover{color:#3879d9}.nav .type a.router-link-active{background-color:#0087ff;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06aacf96","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/component/nav.vue
// module id = 32
// module chunks = 0